import { Link } from "react-router-dom";

const services = [
  {
    id: "residential",
    title: "Residential Window Cleaning",
    tagline: "Sparkling clean for every home",
    icon: "ri-home-4-line",
    image: "https://public.readdy.ai/ai/img_res/6eae2b28a43f66499ba98c985caa43c4.jpg",
    link: "/services#residential",
  },
  {
    id: "commercial",
    title: "Commercial Window Cleaning",
    tagline: "A professional image for your business",
    icon: "ri-building-4-line",
    image: "https://readdy.ai/api/search-image?query=stunning%20modern%20commercial%20office%20building%20exterior%20with%20immaculate%20perfectly%20clean%20floor%20to%20ceiling%20glass%20windows%20reflecting%20blue%20sky%2C%20wide%20angle%20architectural%20shot%2C%20bright%20daylight%2C%20UK%20business%20district%2C%20crystal%20clear%20glass%20facade%20with%20no%20streaks%2C%20photorealistic%20professional%20commercial%20photography%2C%20ultra%20sharp%2C%20no%20people%20visible%2C%20award%20winning%20architecture%20photo&width=600&height=400&seq=svc-com-v3&orientation=landscape",
    link: "/services#commercial",
  },
  {
    id: "conservatory",
    title: "Conservatory & Glass Cleaning",
    tagline: "Restore light and clarity to every pane",
    icon: "ri-sun-cloudy-line",
    image: "https://readdy.ai/api/search-image?query=elegant%20large%20white%20uPVC%20conservatory%20on%20a%20luxury%20UK%20home%20surrounded%20by%20a%20beautiful%20lush%20garden%2C%20interior%20warmly%20lit%20with%20sunlight%20pouring%20through%20perfectly%20transparent%20glass%20panels%20and%20polycarbonate%20roof%2C%20golden%20hour%20light%20casting%20warm%20tones%20on%20immaculate%20glass%20surfaces%2C%20low%20angle%20wide%20exterior%20shot%20showcasing%20the%20full%20conservatory%20structure%2C%20ultra%20sharp%20photorealistic%20professional%20architectural%20photography%2C%20no%20people%2C%20pristine%20spotless%20result%2C%20high%20definition&width=600&height=400&seq=svc-cons-v5&orientation=landscape",
    link: "/services#conservatory",
  },
  {
    id: "maintenance",
    title: "Regular Maintenance Cleaning",
    tagline: "Keep your windows looking their best year-round",
    icon: "ri-calendar-check-line",
    image: "https://readdy.ai/api/search-image?query=spotlessly%20clean%20residential%20UK%20suburban%20street%20with%20immaculate%20gleaming%20house%20windows%20reflecting%20morning%20light%2C%20neat%20detached%20homes%20with%20sparkling%20uPVC%20windows%2C%20white%20professional%20cleaning%20company%20van%20parked%20on%20driveway%20seen%20from%20distance%2C%20bright%20crisp%20morning%2C%20wide%20angle%20street%20photography%2C%20photorealistic%20sharp%2C%20no%20close-up%20faces%20or%20hands&width=600&height=400&seq=svc-maint-v3&orientation=landscape",
    link: "/services#maintenance",
  },
];

export default function ServicesOverview() {
  return (
    <section id="our-services" className="py-24 bg-[#F8FAFE]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <span className="text-[#1E88E5] font-heading font-semibold text-sm uppercase tracking-widest block mb-3">
              What We Do
            </span>
            <h2 className="font-heading font-800 text-[#0F2040] leading-tight" style={{ fontSize: "clamp(1.8rem, 3.5vw, 2.75rem)", fontWeight: 800 }}>
              Comprehensive Window Cleaning<br />Solutions
            </h2>
          </div>
          <p className="text-gray-500 font-body text-base max-w-sm lg:text-right">
            From single homes to large commercial sites across Northfleet, Gravesend, Kent and surrounding areas. — we&apos;ve got you covered.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service) => (
            <article
              key={service.title}
              className="bg-white rounded-2xl overflow-hidden hover:-translate-y-1 transition-all duration-300 border border-gray-100"
            >
              <div className="w-full h-52 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-7">
                <div className="flex items-center gap-3 mb-4">
                  <div
                    className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0"
                    style={{ backgroundColor: service.bgLight }}
                  >
                    <i className={`${service.icon} text-lg`} style={{ color: service.color }}></i>
                  </div>
                  <h3 className="font-heading font-700 text-[#0F2040] text-lg" style={{ fontWeight: 700 }}>
                    {service.title}
                  </h3>
                </div>
                <p className="text-gray-500 font-body text-sm leading-relaxed mb-5">
                  {service.desc}
                </p>
                <Link
                  to="/services"
                  className="inline-flex items-center gap-1.5 text-sm font-semibold cursor-pointer transition-colors hover:gap-2.5"
                  style={{ color: service.color }}
                >
                  Learn More
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </article>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-14 text-center">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 bg-[#1A3A6B] hover:bg-[#0F2040] text-white font-heading font-semibold text-base px-10 py-4 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
          >
            View All Services
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
